export enum EDataLoadingState {
  BEFORE_LOAD = 'BEFORE_LOAD',
  LOADING = 'LOADING',
  LIST_EMPTY = 'LIST_EMPTY',
  LIST_NOT_EMPTY = 'LIST_NOT_EMPTY',
  LIST_ITEMS_NOT_FOUND = 'LIST_ITEMS_NOT_FOUND',
}
